import { reactive } from 'vue';

export const store = reactive({
  formCliente: {},
  formServicos: {},
  formFaturamento: {},
  formInformacoes: {},
  isUpdate: false,
  currentTab: 0,
});
